'use strict';

/**
 * Defines the properties and methods that every child transform class should
 * implement
 */

var LayerStyles = require('./lib/LayerStyles');
var MarkerUtil = require('./lib/MarkerUtil');
var Transform = require('../../../Transform');

var GCPTransform = Transform.extend({

  collection: 'gcps',

  /**
   * The key on the layer under which the GeoJSON data is stored
   * @type {String}
   */
  geojsonKey: 'data',

  /**
   * Default layer styles for different states. Should return an object with
   * three states: active, default, dim
   *
   * @return {Object}
   */
  getLayerStateStyles: function (rlayer) {
    /* jshint unused:false */
    return LayerStyles.marker;
  },

  getModel: function (data) {
    return data;
  },

  /**
   * Transform a layer type into a type that leaflet understands.
   * Should return one of [circle, marker, polygon, polyline, rectangle].
   *
   * @param  {Object} rlayer  Raw layer data
   * @return {String} type {circle|marker|polygon|polyline|rectangle}
   */
  getLeafletTypeFromLayer: function (rlayer) {
    /* jshint unused:false */
    return 'marker';
  },

  isLayerClickable: function (rlayer) {
    /* jshint unused:false */
    return true;
  },

  isLayerEditable: function (rlayer) {
    /* jshint unused:false */
    return false;
  },

  /**
   * This is a callback function executed when Leaflet is generating the layer
   * from the GeoJSON data and is used to convert a `point` into the appropriate
   * LeafletLayer type.
   *
   * @param  {Object} rlayer  Raw layer data
   * @param  {Object} feature GeoJSON feature
   * @param  {Object} latlng  LatLng object
   * @return {Object} LeafletLayer
   */
  pointToLayerFn: function (rlayer, renderOptions, feature, latlng) {

    var icon = MarkerUtil.getIcon({
      id: rlayer.id,
      type: rlayer.type
    });

    return L.marker(latlng, {
      icon: icon,
      id: rlayer.id,
      clickable: true,
      draggable: false
    });
  }
});

module.exports = GCPTransform;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/gcp/GCP.js